
export const PRIORITY_LEVELS = {
  NORMAL: { value: "NORMAL", label: "Normal" },
  HIGH: { value: "HIGH", label: "High" },
  URGENT: { value: "URGENT", label: "Urgent" },
  CRITICAL: { value: "CRITICAL", label: "Critical" },
};

export const ROLE = 'prosecutor';
export const PERMISSION = 'civilcase_related';
export const ROLES_FILTERING_FOR_ADDING_PROSECUTOR_TO_PANEL = ["civilcase_litigation_teamleader", "civilcase_litigation_prosecutor"];




export const CIVILCASE_LITIGATION_TEAMLEADER = "civilcase_litigation_teamleader";
export const CIVIL_CIVILCASE_LITIGATION_PROSECUTOR_ROLE = "civilcase_litigation_prosecutor";
export const CIVIL_CASE_REGISTRAR_ROLE = "civilcase_registrar";
export const CIVIL_CASE_CLERK_ROLE = "civilcase_clerk";
export const CIVILCASE_NONLITIGATION_TEAMLEADER = "civilcase_nonlitigation_teamleader";
export const CIVILCASE_NONLITIGATION_PROSECUTOR_ROLE = "civilcase_nonlitigation_prosecutor";
export const CIVIL_CASE_DIRECTOR_ROLE = "civilcase_director";
export const ZONAL_ATTORNEY_OFFICE_HEAD = "ZonalAttorneyOfficeHead";
export const WOREDA_ATTORNEY_OFFICE_HEAD = "WoredaAttorneyOfficeHead";

export const CIVIL_CASE_TEAMLEADER_ROLE = 'civilcase_litigation_teamleader'
export const CIVIL_CASE_PROSECUTOR_ROLE = 'civilcase_litigation_prosecutor'
export const CRIME_CASE_DIRECTOR_ROLE = 'crimecase_director'

